import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../../../../assets/fe-images/logo.png';
import fbIcon from '../../../../../assets/icons/fb.svg';
import twitterIcon from '../../../../../assets/icons/twitter.svg';
import instaIcon from '../../../../../assets/icons/insta.svg';
import linkedinIcon from '../../../../../assets/icons/linkedin.svg';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="landing-footer">

      {/* ── CTA banner ── */}
      <div className="landing-footer__cta-banner">
        <div className="landing-footer__cta-inner">
          <div className="landing-footer__cta-text">
            <h3>Ready to simplify your scheduling?</h3>
            <p>Join thousands of teams who save hours every week with MeetOcto.</p>
          </div>
          <Link to="/signup">
            <button className="landing-footer__cta-btn">Get Started Free</button>
          </Link>
        </div>
      </div>

      {/* ── Main grid ── */}
      <div className="landing-footer__main">
        <div className="landing-footer__inner">

          {/* Brand column */}
          <div className="landing-footer__brand">
            <div className="landing-footer__logo-wrap">
              <img src={Logo} alt="MeetOcto" className="landing-footer__logo" />
            </div>
            <p className="landing-footer__tagline">
              Smart scheduling for individuals and teams. Save time, reduce no-shows, and grow your business.
            </p>
            <div className="landing-footer__social">
              <a href="#" aria-label="Facebook">
                <img src={fbIcon} alt="Facebook" />
              </a>
              <a href="#" aria-label="Twitter">
                <img src={twitterIcon} alt="Twitter" />
              </a>
              <a href="#" aria-label="Instagram">
                <img src={instaIcon} alt="Instagram" />
              </a>
              <a href="#" aria-label="LinkedIn">
                <img src={linkedinIcon} alt="LinkedIn" />
              </a>
            </div>
          </div>

          {/* Product */}
          <div className="landing-footer__col">
            <h4 className="landing-footer__col-title">Product</h4>
            <ul>
              <li><button onClick={() => scrollTo('features')}>Features</button></li>
              <li><button onClick={() => scrollTo('pricing')}>Pricing</button></li>
              <li><button onClick={() => scrollTo('how-it-works')}>How It Works</button></li>
              <li><button onClick={() => scrollTo('meetocto-for')}>MeetOcto For Teams</button></li>
              <li><button onClick={() => scrollTo('integrations')}>Integrations</button></li>
            </ul>
          </div>

          {/* Company */}
          <div className="landing-footer__col">
            <h4 className="landing-footer__col-title">Company</h4>
            <ul>
              <li><Link to="/terms-of-services">Terms of Service</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Account */}
          <div className="landing-footer__col">
            <h4 className="landing-footer__col-title">Account</h4>
            <ul>
              <li><Link to="/signup">Create Free Account</Link></li>
              <li><Link to="/admin/login">Log In</Link></li>
            </ul>
          </div>

        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="landing-footer__bottom">
        <div className="landing-footer__bottom-inner">
          <p>© {year} MeetOcto. All Rights Reserved.</p>
          <div className="landing-footer__bottom-links">
            <Link to="/terms-of-services">Terms</Link>
            <Link to="/privacy-policy">Privacy</Link>
          </div>
        </div>
      </div>

    </footer>
  );
};
